// Universal base64 UTF-8 decoder - works in both browser and Node.js (SSR)
export const decodeBase64Utf8 = (b64: string) => {
    try {
        // Try browser API first
        if (typeof atob !== 'undefined') {
            const binary = Uint8Array.from(atob(b64), char => char.charCodeAt(0));
            return new TextDecoder('utf-8').decode(binary);
        }

        // Fallback to Node.js Buffer for SSR
        if (typeof Buffer !== 'undefined') {
            return Buffer.from(b64, 'base64').toString('utf-8');
        }

        // Last resort: return as-is
        console.warn('No base64 decoder available, returning original content');
        return b64;
    } catch (error) {
        console.error('Failed to decode base64:', error);
        return b64; // Return original if decoding fails
    }
};

export const encodeBase64Utf8 = (text: string) => {
    try {
        // Try browser API first
        if (typeof btoa !== 'undefined') {
            const binary = new TextEncoder().encode(text);
            return btoa(String.fromCharCode(...binary));
        }

        // Fallback to Node.js Buffer for SSR
        if (typeof Buffer !== 'undefined') {
            return Buffer.from(text, 'utf-8').toString('base64');
        }

        // Last resort: return as-is
        console.warn('No base64 encoder available, returning original content');
        return text;
    } catch (error) {
        console.error('Failed to encode base64:', error);
        return text; // Return original if encoding fails
    }
}